export const AssetProviderTypeDecorator = {
  url() {
    return `signup-hubspot/asset-provider`;
  },
  query() {
    return {};
  }
};